import { render } from "./maternityBenefit.vue?vue&type=template&id=0cf3b286&scoped=true"
import script from "./maternityBenefit.vue?vue&type=script&lang=js"
export * from "./maternityBenefit.vue?vue&type=script&lang=js"

import "./maternityBenefit.vue?vue&type=style&index=0&id=0cf3b286&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf3b286"]])

export default __exports__